import React from 'react';
import classnames from 'classnames';
import WithlocalsLogoSmall from 'components/icons/WithlocalsLogoSmall';
import ChevronIcon from 'components/icons/ChevronIcon';
import MobileList from '../NavbarListItems/MobileList';

const CSS = require('./ListToggleLogo.less');

const PRIMARY_COLOR = '#8B174E';

function ListToggleLogo({ toggleList, transparent, openList, closeList }) {
  return (
    <div>
      <button className={CSS.LogoContainer} onClick={toggleList} aria-label="menu">
        <WithlocalsLogoSmall
          color={transparent ? 'white' : PRIMARY_COLOR}
          width={48}
          height={32}
        />
        <ChevronIcon
          className={classnames(CSS.ChevronIcon, {
            [CSS.ChevronIconRotated]: openList,
            [CSS.ChevronIconTransparent]: transparent,
          })}
          width={9}
          height={5}
          direction="bottom"
        />
      </button>
      {openList && <MobileList onClick={closeList}/>}
    </div>
  );
}

export default ListToggleLogo;
